// Palette
import palette from "../palette";

export default {
  root: {
   /*  borderBottom: `1px solid ${palette.divider}`, */
    padding: "16px 40px 16px 24px",
    fontSize: 13
  },
  head: {
    fontSize: 14,
    background: palette.background.light,
    color: palette.text.primary,
    whiteSpace: "nowrap",
    "&:first-of-type":{
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10
    },
    "&:last-of-type":{
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10
    }
  }
};
